import styled from '@emotion/styled';
import { typography } from '@uniquegood/realworld-studio-design';

interface PlanBadgeProps {
  plan: PlanType;
}

const PLAN_LABELS: Record<Exclude<PlanType, 'Free'>, string> = {
  Pro: 'Pro',
  Enterprise: 'Enterprise',
  Class: 'Class',
  Teacher: 'Teacher',
  Realworld: 'Realworld'
};

const PlanBadge = ({ plan }: PlanBadgeProps) => {
  if (plan === 'Free') {
    return null;
  }

  return <Badge>{PLAN_LABELS[plan]}</Badge>;
};

export default PlanBadge;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 6px;
  background: linear-gradient(90deg, #7800ff 0%, #829bff 100%);
  font-size: 12px;
  line-height: 16px;
  font-weight: ${typography.weight.bold};
  color: #ffffff;
  white-space: nowrap;
`;
